import { render, staticRenderFns } from "./ArticleAuthorList.vue?vue&type=template&id=6f25910a&scoped=true&"
import script from "./ArticleAuthorList.vue?vue&type=script&lang=ts&"
export * from "./ArticleAuthorList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleAuthorList.vue?vue&type=style&index=0&id=6f25910a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f25910a",
  null
  
)

export default component.exports